// extracted by mini-css-extract-plugin
export default {"container":"Landing_container__TIHPx","landing":"Landing_landing__7y4iB","hero":"Landing_hero__ql0pn","heroLogo":"Landing_heroLogo__L12xE","body":"Landing_body__3QnnC"};